import { cn } from "../../lib/utils";

const Card = ({ className, ...props }) => (
  <div className={cn("rounded-2xl border border-border bg-card shadow-card", className)} {...props} />
);
const CardHeader = ({ className, ...props }) => (
  <div className={cn("flex flex-col gap-1.5 p-6", className)} {...props} />
);
const CardTitle = ({ className, ...props }) => (
  <h3 className={cn("text-base font-semibold leading-none text-foreground", className)} {...props} />
);
const CardDescription = ({ className, ...props }) => (
  <p className={cn("text-sm text-muted-foreground", className)} {...props} />
);
const CardContent = ({ className, ...props }) => (
  <div className={cn("p-6 pt-0", className)} {...props} />
);
const CardFooter = ({ className, ...props }) => (
  <div className={cn("flex items-center p-6 pt-0", className)} {...props} />
);

export { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter };
